import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next' // I18N

const PageTitle = (props) => {
    const { t } = useTranslation(); // I18N
    return (
        <section className="wpo-page-title">
            <div className="container">
                <div className="row">
                    <div className="col col-xs-12">
                        <div className="wpo-breadcumb-wrap">
                            <h2  style={props.style}>{props.pageTitle}</h2>
                            <ol className="wpo-breadcumb-wrap">
                                <li><Link to="/">{t('nav.home')}</Link></li>
                                <li>{props.pagesub}</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default PageTitle;





